import React, { memo } from "react";
import styled from "styled-components";
import { useBiblePageContext } from "../../../bible_page_context";
import BibleMainLeftButtons from "./bible_main_left_buttons";
import BibleMainRightButtons from "./bible_main_right_buttons";

const BibileMainButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 12px 12px 10px;
  user-select: none;
`;

const BibileMainButtons = ({
  chapterData,
  bibleId,
  isFirstTranslation,
  currentTranslation,
  bibleTranslations,
  hasSecondTranslaition,
  setOpenBibleSearch,
  setOpenBibleNavigation,
  setOpenBibleTranslation,
  setShowStrongsCode,
}) => {
  const { activeScreenMobile, setActiveScreenMobile, showStrongsCode } =
    useBiblePageContext();

  return (
    <BibileMainButtonsContainer>
      <BibleMainLeftButtons
        isFirstTranslation={isFirstTranslation}
        hasSecondTranslaition={hasSecondTranslaition}
        bibleId={bibleId}
        chapterData={chapterData}
        currentTranslation={currentTranslation}
        setActiveScreenMobile={setActiveScreenMobile}
        setOpenBibleNavigation={setOpenBibleNavigation}
        setOpenBibleTranslation={setOpenBibleTranslation}
      />
      <BibleMainRightButtons
        bibleId={bibleId}
        isFirstTranslation={isFirstTranslation}
        activeScreenMobile={activeScreenMobile}
        showStrongsCode={showStrongsCode}
        bibleTranslations={bibleTranslations}
        setActiveScreenMobile={setActiveScreenMobile}
        setOpenBibleSearch={setOpenBibleSearch}
        setShowStrongsCode={setShowStrongsCode}
      />
    </BibileMainButtonsContainer>
  );
};

export default memo(BibileMainButtons);
